import React, { Component } from 'react'

export default class Solutions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'agencies'
    }
  }

  render() {
    const { activeTab } = this.state;

    const solutions = {
      agencies: {
        title: 'Travel Agencies',
        subtitle: 'Instant Bookings, Effortless Sales.',
        description: 'Simplify Travel Planning, Maximize Client Satisfaction: Travel agencies, collaborate with Holideus to streamline travel planning for your clients while maximizing their satisfaction. Our platform offers an intuitive interface and an extensive catalog of tours, accommodations, activities, and more.',
        features: [
          {
            icon: 'bi bi-diagram-3',
            title: 'Access Supply Without Negotiation',
            text: 'With Holideus, you can tap into a vast network of trusted suppliers and service providers, ensuring that you have a wide range of options at your fingertips. Say goodbye to time-consuming negotiations and complex procurement processes.'
          },
          {
            icon: 'bi bi-hand-thumbs-up',
            title: 'Elevating Client Satisfaction',
            text: 'Partner with Holideus to simplify your services and offer a diverse range of travel options to your clients. Whether you specialize in leisure travel, corporate bookings, or niche markets, we provide the tools to support your business.'
          },
          {
            icon: 'bi bi-lightbulb',
            title: 'Access Exclusive Local Insights',
            text: 'Gain access to exclusive local insights, off-the-beaten-path recommendations, and hidden treasures that can transform your clients trips into truly exceptional journeys. Set your travel agency apart by providing personalized experiences.'
          }
        ]
      },
      providers: {
        title: 'Tour Providers',
        subtitle: 'Digitize Your Operations',
        description: 'Transform your tour business with our comprehensive digital platform. Manage bookings, schedules, and customer relationships all in one place.',
        features: [
          {
            icon: 'bi bi-pc-display',
            title: 'Digital Management',
            text: 'Streamline your operations with our intuitive digital platform. Manage all aspects of your tour business from a single dashboard.'
          },
          {
            icon: 'bi bi-graph-up-arrow',
            title: 'Maximize Revenue',
            text: 'Reach more customers through multiple sales channels. Our platform helps you increase bookings and revenue.'
          },
          {
            icon: 'bi bi-pie-chart',
            title: 'Real-time Analytics',
            text: 'Track your business performance with detailed analytics and insights. Make data-driven decisions to grow your business.'
          }
        ]
      },
      hotels: {
        title: 'Hotels & Accommodations',
        subtitle: 'Expand Your Reach',
        description: 'Connect with travel agencies and tour operators worldwide. Increase your visibility and bookings through our platform.',
        features: [
          {
            icon: 'bi bi-globe-americas',
            title: 'Global Distribution',
            text: 'List your property on our platform and reach travel agencies and customers worldwide. Expand your market reach effortlessly.'
          },
          {
            icon: 'bi bi-hdd-stack',
            title: 'Seamless Integration',
            text: 'Integrate with your existing systems easily. Manage inventory and rates in real-time across all channels.'
          },
          {
            icon: 'bi bi-bullseye',
            title: 'Targeted Marketing',
            text: 'Benefit from our targeted marketing campaigns and promotional opportunities to boost your occupancy rates.'
          }
        ]
      }
    };

    return (
      <div style={{
        padding: '80px 5%',
        backgroundColor: '#fff'
      }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <div style={{
            backgroundColor: 'rgba(77, 184, 205, 0.1)',
            padding: '8px 16px',
            borderRadius: '20px',
            marginBottom: '20px',
            fontSize: '12px',
            color: '#4db8cd',
            fontWeight: '600',
            display: 'inline-block',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            OUR SOLUTIONS
          </div>
          <h2 style={{
            fontSize: '42px',
            fontWeight: '700',
            margin: '0 0 15px 0',
            color: '#1a1a1a'
          }}>
            Tailored Solutions for Every Business
          </h2>
          <p style={{
            color: '#5c636c',
            fontSize: '16px',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Whether you are a travel agency, tour provider, or accommodation business, 
            we have the perfect solution to help you grow and succeed.
          </p>
        </div>

        {/* Tabs */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '15px',
          marginBottom: '50px',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => this.setState({ activeTab: 'agencies' })}
            style={{
              padding: '12px 30px',
              borderRadius: '30px',
              border: activeTab === 'agencies' ? '2px solid #4db8cd' : '2px solid #e0f7fa',
              backgroundColor: activeTab === 'agencies' ? '#4db8cd' : '#fff',
              color: activeTab === 'agencies' ? '#fff' : '#5c636c',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              outline: 'none'
            }}
          >
            Travel Agencies
          </button>
          <button
            onClick={() => this.setState({ activeTab: 'providers' })}
            style={{
              padding: '12px 30px',
              borderRadius: '30px',
              border: activeTab === 'providers' ? '2px solid #4db8cd' : '2px solid #e0f7fa',
              backgroundColor: activeTab === 'providers' ? '#4db8cd' : '#fff',
              color: activeTab === 'providers' ? '#fff' : '#5c636c',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              outline: 'none'
            }}
          >
            Tour Providers
          </button>
          <button
            onClick={() => this.setState({ activeTab: 'hotels' })}
            style={{
              padding: '12px 30px',
              borderRadius: '30px',
              border: activeTab === 'hotels' ? '2px solid #4db8cd' : '2px solid #e0f7fa',
              backgroundColor: activeTab === 'hotels' ? '#4db8cd' : '#fff',
              color: activeTab === 'hotels' ? '#fff' : '#5c636c',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              outline: 'none'
            }}
          >
            Hotels & Accommodations
          </button>
        </div>

        {/* Content */}
        <div style={{
          backgroundColor: 'rgba(236, 246, 248, 0.5)',
          borderRadius: '20px',
          padding: '50px',
          border: '1px solid rgb(222, 240, 244)'
        }}>
          {/* Title Section */}
          <div style={{ marginBottom: '40px', textAlign: 'center' }}>
            <h3 style={{
              fontSize: '36px',
              fontWeight: '700',
              margin: '0 0 10px 0',
              color: '#1a1a1a'
            }}>
              {solutions[activeTab].title}
            </h3>
            <p style={{
              fontSize: '20px',
              color: '#4db8cd',
              fontWeight: '600',
              margin: '0 0 20px 0'
            }}>
              {solutions[activeTab].subtitle}
            </p>
            <p style={{
              fontSize: '16px',
              color: '#5c636c',
              lineHeight: '1.8',
              maxWidth: '900px',
              margin: '0 auto'
            }}>
              {solutions[activeTab].description}
            </p>
          </div>

          {/* Features Grid */}
          <div className='row' style={{ marginTop: '40px' }}>
            {solutions[activeTab].features.map((feature, index) => (
              <div key={index} className='col-md-4 mb-4'>
                <div style={{
                  backgroundColor: '#fff',
                  borderRadius: '15px',
                  padding: '30px',
                  height: '100%',
                  boxShadow: '0 4px 15px rgba(77, 184, 205, 0.1)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(77, 184, 205, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(77, 184, 205, 0.1)';
                }}
                >
                  <div style={{
                    fontSize: '40px',
                    marginBottom: '20px',
                    color: '#4db8cd'
                  }}>
                    <i className={feature.icon}></i>
                  </div>
                  <h4 style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    marginBottom: '15px'
                  }}>
                    {feature.title}
                  </h4>
                  <p style={{
                    fontSize: '14px',
                    color: '#5c636c',
                    lineHeight: '1.6',
                    margin: 0
                  }}>
                    {feature.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <button style={{
              backgroundColor: '#4db8cd',
              color: 'white',
              border: 'none',
              padding: '15px 40px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(77, 184, 205, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#3da5ba';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#4db8cd';
              e.target.style.transform = 'translateY(0)';
            }}
            >
              Get Started Today
            </button>
          </div>
        </div>
      </div>
    )
  }
}
